<template>
  <div class="wrap">
    <div class="detailsTop">
      <van-nav-bar title="领取产品" left-arrow @click-left="$router.go(-1)" />
    </div>
    <!-- 地址 -->
    <!-- <div class="address-container" @click="changeAddress">
      <img src="../../assets/imgs/home/address.png" alt style="width: 30px;height: 30px;margin-right: 15px;" />
      <div class="address-info" v-if="isOk">
        <div class="address-info-top">
          <span>{{chooseAddress.name}}</span>
          <span>{{chooseAddress.phone}}</span>
          <div style="margin-top:13.5px" class="address-info-bottom van-ellipsis">{{chooseAddress.address}}
            {{chooseAddress.detail}}</div>
        </div>
        <div>
          <img src="../../assets/imgs/home/addressMore.png" alt="" style="width:9px;height:16px;">
        </div>
      </div>
      <div v-else style='font-size:12px;'>
        请添加收货地址!
      </div>
    </div> -->
    <!-- 地址 -->
    <div class="trialCon">
      <div class="trialOrder">
        <span>
          &nbsp; &nbsp; 您本月可免费领取数量{{trialOrderCount}}件
        </span>
      </div>
      <!-- 收货信息 -->
      <div class="conAddress">
        <div class="addressTop">
          <div>
            收货信息
          </div>
          <div @click="changeAddress">
            切换地址
          </div>
        </div>
        <van-field v-model="chooseAddress.name" label="姓名" input-align="left" readonly="true" />
        <van-field v-model="chooseAddress.phone" label="手机" input-align="left" readonly="true" />
        <van-field v-model="chooseAddress.address" label="地区" input-align="left" readonly="true" />
        <van-field v-model="chooseAddress.detail" label="地址" input-align="left" readonly="true" />
      </div>
    </div>
    <div class="integralCon">
      <div class="integralTop">
        <div>
          支付方式
        </div>
        <div>
          邮费:{{freight}}
        </div>
      </div>
      <div style="font-size:14px;font-weight:550">
        侯先森积分
      </div>
    </div>
    <van-button color='#3B6BFB' round class="submitBtn" @click="onSubmit">确认提交</van-button>
    <!-- <div class="orderGoods">
      <div>
        <img :src="chooseGoods.image" alt />
      </div>
      <div class="orderCon">
        <div class="orderName">{{chooseGoods.name}}</div>
        <div style="margin-top:10px;">{{chooseGoods.attributes}}</div>
        <div class="orderNum">
          <div>￥0.00</div>
          <div>*1</div>
        </div>
        <div>
          邮费:
          {{chooseGoods.freight}}
        </div>
        <div class="orderPrice">
          商品金额:
          <span>￥0.00</span>
        </div>
      </div>
    </div> -->
    <!-- <div class="gap"></div>
    <div class="payItem">
      <div class="itemTitle">支付方式</div>
      <van-cell title="侯先森积分">
      </van-cell>
    </div> -->
    <!-- <van-submit-bar
        :price="orderData.is_deduct==1?((chooseGoods.freight-account)*100>0?(chooseGoods.freight-account)*100:0.00):(chooseGoods.freight)*100"
        button-text="提交订单" @submit="onSubmit" button-color="linear-gradient(#008FFF,#007EFF)" /> -->
    <!-- 输入密码 -->
    <van-dialog v-model="showPassword" title="支付密码" show-cancel-button @confirm="pay" @cancel="cancelPay"
      :before-close="beforePasswordClose">
      <van-password-input :value="password" info="密码为 6 位数字类型" style="position:initial" />
    </van-dialog>
    <van-number-keyboard id="keyboard-panel" :show="showPassword" @input="onInput" @delete="onDelete" :z-index="9999"
      style="color:black" />
  </div>
</template>
<script>
  import { addressList, defaultAddress, userAccount, trialOrder } from "@/api/personal";
  import { trialOrderCount } from "@/api/home";
  import "../../utils/emptyVue";
  export default {
    data() {
      return {
        freight:0,
        id: "",
        isOk: false,
        adress: {},
        list: [],
        addresss: {},
        chooseGoods: {},
        userPid: "",
        chooseAddress: {},
        password: "",
        showPassword: false,
        orderData: {
          goods_id: '',
          address_id: "",
        },
        account: 0,
        trialOrderCount: 0
      };
    },
    created() {
      // 获取地址
      this.orderData.goods_id = this.$route.query.id;
      this.freight=  this.$route.query.freight;
      // let chooseAddress = localStorage.getItem("chooseAddress")||{};
      // if (chooseAddress) {
      //   this.chooseAddress = JSON.parse(chooseAddress);
      // } else {
      defaultAddress().then(res => {
        if (res.id) {
          this.chooseAddress = res;
          this.isOk = true;
        }
      });
      trialOrderCount().then(res => {
        this.trialOrderCount = res.count
      })
      // }
      if (this.chooseAddress.id) {
        this.isOk = true;
      }
      userAccount().then(res => {
        this.account = res[2];
      })
    },
    methods: {
      //-------------输入密码开始
      beforePasswordClose(action, done) {
        if (action === "confirm") {
          if (this.orderData.pay_password.length != 6) {
            done(false);
          } else {
            done();
          }
        } else {
          done();
        }
      },
      cancelPay() {
        this.password = "";
      },
      pay() {
        if (this.password.length != 6) {
          this.$toast("请输入6位数字密码");
          return false;
        }
        this.$toast.loading({ message: "处理中...", mask: true });
        this.orderData.pay_password = this.password;
        trialOrder(this.orderData).then(res => {
          this.$toast('您已成功下单！');
          this.showPassword = false;
          setTimeout(() => {
            this.$router.replace({ path: 'myOrder', query: { active: 0, status: 0 } })
          }, 200)
        });
      },
      // 键盘相关事件响应
      onInput(key) {
        this.password = (this.password + key).slice(0, 6);
        this.zIndex = 9999;
      },
      onDelete() {
        this.password = this.password.slice(0, this.password.length - 1);
      },
      //------------- 输入密码结束
      onSubmit() {
        if (!this.chooseAddress) {
          this.$toast("请选择收货地址");
          return;
        }
        this.orderData.address_id=this.chooseAddress.id || 0;
        this.showPassword = true;
      },
      //选择地址
      changeAddress() {
        this.$router.push({
          path: `myAddress`,
          query: {
            type: 1
          }
        });
      }
    }
  };
</script>
<style lang="less" scoped>
  .trialOrder {
    height: 40px;
    font-size: 15px;
    line-height: 40px;
    background-color: #03BAFE;
    width: 100%;
    border-radius: 6px 6px 0 0;
  }

  .trialOrder span {
    color: #fff;
  }

  .gap {
    width: 100%;
    height: 8px;
    background: #f5f5f5;
  }

  .textarea {
    height: 100px;
  }

  .payItem {
    width: 100%;
    background: #fff;
    padding: 10px;
    box-sizing: border-box;
    font-size: 15px;

    .itemTitle {
      font-weight: bold;
      margin-bottom: 10px;
    }

    .van-cell {
      padding: 0;
    }
  }

  .chooseItem {
    display: flex;
    align-items: center;
  }

  .van-cell::after {
    border: 0 none;
  }

  /deep/.van-nav-bar {
    background: #3B6BFB;

    .van-nav-bar__title {
      color: white;
    }

    .van-icon {
      color: white;
    }
  }

  .van-stepper {
    text-align: right;
  }

  .van-card {
    background: white;
  }

  .van-cell__value {
    color: #FA4A42;
  }

  .van-submit-bar__text {
    text-align: left;
  }

  .van-submit-bar__price {
    color: #FA4A42;
  }

  .wrap {
    width: 100%;
    height: 100vh;
    background: #f5f4f7;
  }

  [class*="van-hairline"]::after {
    border: 0 none;
  }

  .detailsTop {
    width: 100%;
  }

  .address-container {
    background: white;
    padding: 13px 20px;
    border-radius: 4px;
    display: flex;
    height: 82.5px;
    align-items: center;
    border-bottom: 1px solid #c1c1c1;
    box-sizing: border-box;

    .location-img {
      width: 36px;
      height: 36px;
      margin-right: 10px;
    }

    .address-info {
      width: 350px;
      display: flex;
      justify-content: space-between;
      font-size: 12px;

      .address-info-top {
        >span:first-child {
          margin-right: 20px;
        }

        >span:last-child {
          color: #a8a8a8;
        }
      }
    }

    .no-default-address {
      font-size: 12px;
      color: #a8a8a8;
      width: 267px;
    }

    .arrow-icon {
      font-size: 16px;
    }

    .content {
      display: inline-block;
      vertical-align: top;
      margin-top: 9px;
      font-size: 16px;

      p {
        margin: 0;
        font-size: 15px;
        line-height: 8px;

        span {
          color: #999999;
        }
      }

      >span {
        font-size: 12px;
        line-height: 45px;
      }
    }
  }

  .orderGoods {
    width: 100%;
    box-sizing: border-box;
    padding: 16px;
    background: #fff;
    color: #161e28;
    font-size: 14px;
    display: flex;
    justify-content: space-between;

    img {
      width: 100.5px;
      height: 77.5px;
      border-radius: 5px;
    }

    .orderCon {
      width: 65%;

      .orderNum {
        margin: 20px 0 10px;
        display: flex;
        justify-content: space-between;
        color: #666666;

        div {
          &:first-child {
            color: #FA4A42;
          }
        }
      }

      .orderPrice {
        float: right;

        span {
          color: #FA4A42;
        }
      }
    }
  }

  .order-item-wrapper {
    margin-top: 10px;
    padding: 0 15px;
    background-color: #fff;
    font-size: 13px;

    .van-cell {
      padding-left: 0px;
    }

    .order-header {
      height: 34px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #f6f3f3;
    }

    .order-body {
      box-sizing: border-box;
      height: 120px;
      padding: 10px 0;
      border-bottom: 1px solid #f6f3f3;

      &-pic {
        width: 100px;
        height: 100px;
        float: left;
        margin-right: 15px;
        background-color: #eee;

        .van-image {
          width: 100%;
          height: 100%;
        }
      }

      &-info {
        float: left;
        width: 200px;
        height: 100px;

        &-name {
          height: 50px;
          line-height: 25px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }

        &-price {
          height: 25px;
          line-height: 25px;
          font-size: 12px;
          color: #ff6666;
        }

        &-num {
          line-height: 25px;
          font-size: 10px;
        }
      }
    }

    .order-bottom {
      height: 36px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &-ctr {
        width: 100%;

        .itemNum {
          color: #333;
          font-size: 12px;
        }

        .itemPrice {
          span:last-child {
            color: #de4f53;
            font-size: 18px;
          }
        }

        .van-button {
          margin-left: 15px;
          padding: 0 10px;
        }
      }
    }

    .orange-color {
      color: #e94c04;
      border-color: #e94c04;
    }
  }

  .midItem {
    margin-top: 12px;
    margin-bottom: 14px;
    font-size: 11px;
    color: #666;

    .midNum {
      color: #bb5b5c;
    }
  }

  .orderInfo {
    margin: 0 auto;
    background: #fff;
    box-sizing: border-box;
    width: 345px;
    border-radius: 10px;
    height: 153px;
    box-shadow: 0 0 6px 1px #f5f5f5;
    color: #333;
    font-size: 14px;

    .infoTitle {
      padding: 16px 20px 12px 15px;
      font-size: 14px;

      .orderStatus {
        color: #fe9820;
      }
    }

    .infoCon {
      padding: 0 0 16px 15px;
    }
  }

  .popBtn {
    width: 100%;
    position: fixed;
    left: 0;
    bottom: 0;
    background: #fff;
    height: 52.5px;
    z-index: 1000;
    // padding-top: 14px;
    box-sizing: border-box;

    .van-button {
      height: 27px;
      border: 0 none;
      font-size: 14px;
      width: 94.5px;
      color: #fff;
      line-height: 27px;
      padding: 0;
      border-radius: 13.5px;
    }

    .carBtn {
      background: #1e854c;
      margin-right: 2.5px;
    }

    .buyBtn {
      background: linear-gradient(to right, #ff6e02, #ffcc33);
      margin-right: 25px;
    }
  }

  /deep/ .van-stepper__minus {
    width: 20px;
    height: 20px;
  }

  /deep/ .van-stepper__input {
    width: 20px;
    height: 20px;
  }

  /deep/ .van-stepper__plus {
    width: 20px;
    height: 20px;
  }

  .popPsd {
    position: fixed;
    z-index: 2;
    left: 0;
    top: 0;
    background: #fff;
    transform: 0.5;
    overflow: hidden;
    height: auto;
    width: 100%;
  }

  /deep/ .van-dialog__header {
    color: #000;
    margin-bottom: 20px
  }

  .van-password-input {
    position: relative;
    width: 90%;
    margin: 0 auto;
    margin-top: 10px;

    li {
      border: 1px solid #c1c1c1;
    }
  }

  .trialCon {
    width: 360px;
    border-radius: 6px;
    background: #fff;
    margin: 10px auto;
    padding-bottom: 15px;
  }

  .conAddress {
    .van-cell:not(:last-child) {
      border-bottom: 1px solid #f5f5f5;
    }

    /deep/ .van-field__label {
      color: #000;
    }

    /deep/ .van-field__control {
      color: #666;
    }
  }

  .addressTop {
    box-sizing: border-box;
    padding: 0 15px;
    margin: 10px 0 5px;
    display: flex;
    font-size: 15px;
    justify-content: space-between;

    div {
      &:first-child {
        font-weight: bold;
      }

      &:last-child {
        color: #666;
        font-size: 14px;
      }
    }
  }

  .integralCon {
    width: 360px;
    border-radius: 6px;
    background: #fff;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 15px;
  
  }

  .integralTop {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    div {
      &:first-child {
        font-weight: bold;
        font-size: 16px;
      }

      &:last-child {
        color: #FA4A42;
        font-size: 13px;
      }
    }
  }
  .submitBtn{
    width:350px;
    display: block;
    margin:20px auto;
  }
</style>